module.exports = __webpack_public_path__ + "img/zerocarbon3.6c568793.png";